import * as Yup from "yup";

const validationSchema = (schema: any) => {
  const valid = Yup.object({
    password: Yup.string()
      .required(schema.isRequired)

      .test("length", schema.shortPass, (val: any) => {
        return val && val.length >= 5;
      }),
    confirmPassword: Yup.string()
      .required(schema.confirmPassword)
      .test("length", schema.shortPass, (val: any) => {
        return val && val.length >= 5;
      })
      .test("passwords-match", schema.match, function (value) {
        return this.parent.password === value;
      }),
  });
  return valid;
};

export default validationSchema;
